import State from "slotworks/state-machine/states/state";
import HarleyComponents from "components/components";
import { parallel, sequence } from "slotworks/utils/race-utils";
import CelebrateScatterCommand from "commands/celebrate-scatter-command";
import Contract from "slotworks/utils/contract";
import { DimSymbolsCommand } from "slotworks/commands/symbols/dim-symbols-command";
import Components from "slotworks/components/components";
import soundManager from "slotworks/sound/sound-manager";
import gameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import FreespinsWheelResult from "integration/results/freespins-wheel-result";
import Layers from "slotworks/graphics/layers/layers";


export default class FreespinsWheel extends State {

    public onEnter(cascadeSkip?: boolean): void {
        HarleyComponents.quickHit.stop();
        sequence([
            () => DimSymbolsCommand(Components.matrix.getGridSymbols()),
            () => this.celebrateScatter(),
            () => Contract.getTimeoutContract(100),
            () => parallel([
                () => sequence([
                    () => Layers.Custom.get("Transition").setScene("fs"),
                    () => Layers.Custom.get("Transition").defaultScene(),
                ]),
                () => HarleyComponents.freespinsIntro.start(),
            ])
        ]).then(() => super.complete());
    }

    private celebrateScatter() {
        const record = gameState.getCurrentGame().getCurrentRecord() as SpinRecord;
        const results = record.getResultsOfType(FreespinsWheelResult) as FreespinsWheelResult[];
        
        if(results.length > 0 && results[0].buyout) {
            return Contract.empty();
        }
        
        soundManager.customEvent("symbol_SCATTER_win_1");
        return CelebrateScatterCommand();
    }
}